import { ISbAlternateObject, ISbStoryData } from 'storyblok-js-client';

export interface Alternate extends ISbAlternateObject {
  /* Returned only if using the REST Api */
  full_slug: string;
  teaser_title?: string;
  /* Returned only if using the GraphQL Api */
  fullSlug?: string;
  url?: string;
  locale?: string;
}

export interface StoryDataFromGraphQLQuery extends ISbStoryData {
  lang: string;
  alternates: Alternate[];
  allSpaceLocales?: string[];
}

export enum TextDirection {
  LTR = 'ltr',
  RTL = 'rtl',
}
